






















































































import {Component, Prop} from 'vue-property-decorator'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {NftCollection} from '@/model/resource/NftCollection'
import NetworkTag from '@/components/NetworkTag.vue'

@Component({
  components: {NetworkTag},
})
export default class NftCollectionCellRender extends MixinScreenSize {
  @Prop({type: NftCollection, required: true}) nftCollection!: NftCollection

  get formattedAddress() {
    if (!this.nftCollection.ownerAddress) return undefined

    return `${this.nftCollection.ownerAddress.slice(
      0,
      4
    )}...${this.nftCollection.ownerAddress.slice(-4)}`
  }

  get formattedCollectionName() {
    let length = 30

    if (
      this.isLessThanTablet ||
      this.isTablet ||
      this.isSmallDesktop ||
      this.isDesktop
    ) {
      length = 25
    }

    const slicedName = this.nftCollection.name?.slice(0, length) ?? ''

    return this.isNftCollectionNameTruncated
      ? `${slicedName}...`
      : this.nftCollection.name
  }

  get isNftCollectionNameTruncated() {
    const nftCollectionName = this.nftCollection.name ?? ''

    return nftCollectionName.length >= 35
  }

  copyToClipboard() {
    this.$utils.copyToClipboard(this.nftCollection.ownerAddress ?? '')
    this.$toast.info('system.info.copiedToClipboard')
  }
}
